import { capitalizeFirstLetter } from './capitalize-first-letter/capitalize-first-letter.function';
import { RegExp } from './constants';

export function getPageNameFromRoute(route: string): string {
  const page = route?.split('?')[0].split('/')[1] || '';
  const name = page.replace(RegExp.onlyLetters, ' ').trim();
  const capitalizedName = capitalizeFirstLetter(name);

  return `The ${capitalizedName} page`;
}
